"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredGeneralGs1BolInfo = void 0;
exports.RequiredGeneralGs1BolInfo = {
    BolNumber: 'BOL_NUMBER',
    CarrierName: 'CARRIER_NAME',
    CarrierScac: 'CARRIER_SCAC',
    CarrierSignatureAndDate: 'CARRIER_SIGNATURE_AND_DATE',
    DestinationAddress: 'DESTINATION_ADDRESS',
    FreightChargeTerms: 'FREIGHT_CHARGE_TERMS',
    MasterBolIndicator: 'MASTER_BOL_INDICATOR',
    OriginAddress: 'ORIGIN_ADDRESS',
    PartyThatLoadedTrailer: 'PARTY_THAT_LOADED_TRAILER',
    PartyThatCountedFreight: 'PARTY_THAT_COUNTED_FREIGHT',
    TotalPackageQuantity: 'TOTAL_PACKAGE_QUANTITY',
    ShipperSignatureDate: 'SHIPPER_SIGNATURE_DATE'
};
//# sourceMappingURL=required-general-gs1-bol-info.js.map